import Placeholder from '@/components/Placeholder.jsx';

const LogEntriesPlaceholder = () => {
  return (
    <Placeholder rows={6}>
      <Placeholder.Row style={{ marginLeft: '-8px', marginRight: '-8px' }}>
        <Placeholder.Left>
          <Placeholder.Icon />
          <Placeholder.Text width={160} />
        </Placeholder.Left>
        <Placeholder.Right>
          <Placeholder.Text width={60} />
        </Placeholder.Right>
      </Placeholder.Row>
    </Placeholder>
  );
};

export default LogEntriesPlaceholder;
